import { render } from "./UploadSong.vue?vue&type=template&id=7da8d69a"
import script from "./UploadSong.vue?vue&type=script&lang=js"
export * from "./UploadSong.vue?vue&type=script&lang=js"

import "./UploadSong.vue?vue&type=style&index=0&id=7da8d69a&lang=css"
script.render = render

export default script